import { Loader, LoaderOptions } from '@googlemaps/js-api-loader';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';

export enum GoogleMapApiLoadingStatus {
  LOADING = 'LOADING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export interface WrapperProps extends Omit<LoaderOptions, 'apiKey'> {
  children?: ReactNode;
  apiKey?: string;
  render?: (status: GoogleMapApiLoadingStatus) => ReactElement;
  callback?: (status: GoogleMapApiLoadingStatus, loader: Loader) => void;
}

export const GoogleMapsApiWrapper = ({
  children,
  render,
  callback,
  ...options
}: WrapperProps): ReactElement => {
  const [status, setStatus] = useState(GoogleMapApiLoadingStatus.LOADING);

  useEffect(() => {
    const loader = new Loader({
      ...options,
      apiKey: process.env.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY as string
    });

    const setStatusAndExecuteCallback = (status: GoogleMapApiLoadingStatus) => {
      if (callback) callback(status, loader);
      setStatus(status);
    };

    setStatusAndExecuteCallback(GoogleMapApiLoadingStatus.LOADING);

    loader.load().then(
      () => setStatusAndExecuteCallback(GoogleMapApiLoadingStatus.SUCCESS),
      () => setStatusAndExecuteCallback(GoogleMapApiLoadingStatus.FAILURE)
    );
    //eslint-disable-next-line
  }, []);

  if (status === GoogleMapApiLoadingStatus.SUCCESS && children) return <>{children}</>;

  if (render) return render(status);

  return <></>;
};
